import Model from './Model'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export default class Site extends Model {
  resource() {
    return 'sites'
  }

  isUserRole(roles = []) {
    let check = Array.isArray(roles) ? roles : [roles]
    return this.userRole
      ? check.includes(this.userRole.toString().toUpperCase())
      : false
  }

  get userRole() {
    return this.role
  }

  get addedDate() {
    return dayjs
      .utc(this.created_at)
      .format('DD/MMM/YYYY')
      .toUpperCase()
  }

  get canViewUser() {
    return this.isUserRole(['SITE_OWNER', 'SITE_OPERATION', 'SITE_HEAD_SPARKY'])
  }

  get canViewCompliance() {
    return this.isUserRole(['SITE_OWNER', 'SITE_OPERATION', 'SITE_HEAD_SPARKY'])
  }
}
